// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"cd9a4e06","453":"6a91cd1b","664":"08200c22"}[chunkId] + ".chunk.js";
};